import React, { useEffect, useState } from "react";
import { Button,Form, Grid, Input, message, Spin, theme, Typography } from "antd";
import { ContainerOutlined, MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import logoDigiconnex from "../../assets/images/digiconnex.jpg";
import api from "../../API";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Title } = Typography;

const SignUp = () => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if(sessionStorage.getItem('user_id') && sessionStorage.getItem('count')){
      sessionStorage.removeItem('user_id');
      sessionStorage.removeItem('count');
    }
  }, []);

  const handleSignUp = async (values) => {
    try {
      setLoading(true);
      const reponse = await api.signUp(values);
      sessionStorage.setItem('user_id', reponse?.user?.insertId);
      sessionStorage.setItem('count', 0);
      message.success(reponse.message);
      navigate('/register-verify')
    } catch (error) {
      console.log(error);
      message.error(error.message);
    } finally{
      setLoading(false);
    }
  };

  const styles = {
    container: {
      padding: screens.md
      ? `${token.paddingXL}px`
      : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
      borderRadius: 10,
      boxShadow: token.boxShadow,
    },
    forgotPassword: {
      float: "right",
    },
    header: {
      textAlign: "center",
    },
    section: {
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      height: "100vh",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
      textAlign: "center",
      margin: "16px 0px",
      fontWeight: "bold",
    },
    image: {},
  };

  return (
    <Spin spinning={loading}>
      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.header}>
            <img src={logoDigiconnex} width={180} alt="digiconnex"></img>
            <Title style={styles.title}>Sign up</Title>
          </div>
          <Form name="normal_SignUp" onFinish={handleSignUp} layout="vertical" requiredMark="optional">
            <Form.Item  name='email' rules={[{required: true, message: 'Please input your email'}, {type: 'email', message:'Email is incorrect'}]}>
              <Input prefix={<MailOutlined />} placeholder='Email'/>
            </Form.Item>
            <Form.Item  name='phone' rules={[{required: true, message: 'Please input your phone'}, {pattern: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, message: 'Phone number is incorrect'}]}>
              <Input prefix={<PhoneOutlined />} maxLength={10} placeholder='Phone'/>
            </Form.Item>
            <Form.Item  name='TaxCode' rules={[{required: true, message: 'Please input your tax code'}]}>
              <Input prefix={<ContainerOutlined />} placeholder='Tax code'/>
            </Form.Item>
            <Form.Item style={{ marginBottom: "0px" }}>
              <Button
                block="true"
                type="primary"
                size="large"
                htmlType="submit"
              >
                Sign up
              </Button>
            </Form.Item>
          </Form>
          <Typography.Paragraph style={{marginTop: 16}}>Already have an account? <Link to="/login">Log in now</Link></Typography.Paragraph>
        </div>
      </section>
    </Spin>
  );
};
export default SignUp;
